import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {createTheme, MantineProvider} from "@mantine/core";

import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
  /** Put your mantine theme override here */
});

root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <App/>
    </MantineProvider>
  </React.StrictMode>
);
